import autobind from "autobind-decorator";

export default class Pricing {
  constructor(container) {
    if (!container) return;

    this.container = container;

    this.container.parentElement.addEventListener(
      "ItemNumber.change",
      this.itemNumberChange,
    );
  }

  @autobind
  itemNumberChange(event) {
    const itemNumber = event.detail;
    (this.container.querySelector("#baseFrom") || {}).hidden = true;
    (this.container.querySelector("#firstUOM") || {}).hidden = false;

    this.container
      .querySelectorAll("[data-target=priceInnerTarget]")
      .forEach((e) => {
        const element = e;

        element.hidden = element.dataset.item !== itemNumber.toString();
      });
  }
}
